import React, { useState, useContext } from 'react';
import AIGLogo from '../assets/images/aig-logo.svg';
import classnames from 'classnames';
import styles from './Header.module.css';
import { Nav, NavItem, NavLink, NavbarToggler, Collapse, Modal, ModalBody, Navbar } from 'reactstrap';
import CloseMobile from '../assets/images/close-mobile.svg';
import { useLogout } from '../components/shared/logout';
import { ContractContext } from '../components/contexts/ContractContext';
import { useLogoHandler } from './shared/LogoHandler';
import getClientContent from '../components/_BrandingProvider/brandContent';

export const Header = (props) => {
    const context = useContext(ContractContext);
    const [activeTab, setActiveTab] = useState('1');
    const [isOpen, setIsOpen] = useState(false);
    const { logout } = useLogout();
    const { SavePrompt, onLogoClick } = useLogoHandler();
    const headerLinks =
        getClientContent(context.data?.clientId)?.variableText?.headerLinks
        || getClientContent('aig')?.variableText?.headerLinks;

    const handleLogoClick = (event) => {
        event.preventDefault();
        onLogoClick(event);
    };

    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
        linkToRedirect(tab);
    };

    const linkToRedirect = (actionId) => {
        let route = '';
        switch (actionId) {
            case '1': {
                route = 'faq';
                break;
            }
            case '2': {
                route = 'coveragedocs';
                break;
            }
            case '3': {
                route = 'info/contact-us';
                break;
            }
        }
        const link = `/${route}`;
        window.open(link, '_blank');
    };

    const toggleClose = () => {
        setIsOpen(!isOpen);
    };

    // HELPER TO WRAP AND THUS ONLY HAVE TO MAINTAIN ONE MENU INSTEAD OF TWO
    const ConditionalNavWrapper = ({ children }) =>
        isOpen ? (
            <Modal
                isOpen={true}
                toggle={toggle}
                className={`md header-content ${styles.navMenu}`}
                aria-modal='true'
            >
                <a onClick={toggleClose}>
                    <img
                        tabIndex={0}
                        className={`logoClose ${styles.closeButton}`}
                        src={CloseMobile}
                        alt='Close'
                    />
                </a>
                <ModalBody>{children}</ModalBody>
            </Modal>
        ) : (
            <Collapse navbar>{children}</Collapse>
        );

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <header>
                <div className='container px-0'>
                    <div className={styles.navContainer}>
                        <div className={styles.logoContainer}>
                            <a onClick={(event) => handleLogoClick(event)}>
                                <img
                                    className='logo'
                                    src={AIGLogo}
                                    alt='AIG'
                                />
                            </a>
                        </div>
                        <Navbar
                            light
                            expand='md'
                            role='navigation'
                            className={styles.mobileNav}
                        >
                            <NavbarToggler
                                aria-label='On click opens a navigation menu'
                                onClick={toggleMenu}
                            />
                            <ConditionalNavWrapper>
                                <Nav
                                    className={classnames('ml-auto', styles.navTabs)}
                                    navbar
                                >
                                    {headerLinks?.faqs && (
                                        <NavItem>
                                            <NavLink
                                                className={{ active: activeTab === '1' }}
                                                onClick={() => {
                                                    toggle('1');
                                                }}
                                            >
                                                FAQs
                                            </NavLink>
                                        </NavItem>
                                    )}
                                    {headerLinks?.coverageDocs && (
                                        <NavItem>
                                            <NavLink
                                                className={{ active: activeTab === '2' }}
                                                onClick={() => {
                                                    toggle('2');
                                                }}
                                            >
                                                Coverage Documents
                                            </NavLink>
                                        </NavItem>
                                    )}
                                    {headerLinks?.contactUs && (
                                        <NavItem>
                                            <NavLink
                                                className={{ active: activeTab === '3' }}
                                                onClick={() => {
                                                    toggle('3');
                                                }}
                                            >
                                                Contact Us
                                            </NavLink>
                                        </NavItem>
                                    )}
                                    {context?.data?.loggedIn && (
                                        <NavItem>
                                            <NavLink onClick={() => logout()}>Logout</NavLink>
                                        </NavItem>
                                    )}
                                </Nav>
                            </ConditionalNavWrapper>
                        </Navbar>
                    </div>
                </div>
            </header>
            <SavePrompt />
        </>
    );
};
